import { render } from "./MultiSelect.vue?vue&type=template&id=296e8912&ts=true"
import script from "./MultiSelect.ts?vue&type=script&lang=ts&external"
export * from "./MultiSelect.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__